import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Es solo un recetario?',
  answer: 'No. Es un sistema organizado por etapas reales del desarrollo.'
}, {
  question: '¿Sirve si hago BLW?',
  answer: 'Sí. Incluye cortes seguros y adaptación por edad.'
}, {
  question: '¿Necesito experiencia en cocina?',
  answer: 'No. El sistema está pensado para mamás sin experiencia en cocina. Las recetas son simples, con ingredientes fáciles de conseguir y explicadas paso a paso.'
}, {
  question: '¿Y si tengo poco tiempo?',
  answer: 'Incluye batch cooking y menús semanales listos.'
}, {
  question: '¿Qué pasa si mi bebé rechaza algunos alimentos?',
  answer: 'Es normal. El sistema te muestra cómo manejar la etapa selectiva y seguir ampliando la dieta de tu bebé.'
}, {
  question: '¿Desde qué edad puedo usarlo?',
  answer: 'Desde los 6 meses hasta los 3 años.'
}, {
  question: '¿Cuánto tiempo tengo acceso?',
  answer: 'Acceso de por vida. Sin renovaciones.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4 max-w-3xl mx-auto" data-id="element-8">
      {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden shadow-sm" data-id="element-9">
          <button className="w-full px-6 py-4 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-10">
            <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-11">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-12" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-13" />}
          </button>

          {openIndex === index && <div className="px-6 pb-6 pt-2 text-gray-600 leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-14">
              {faq.answer}
            </div>}
        </div>)}
    </div>;
}